import React, { createContext, useState, useEffect } from "react";
import { auth } from "../../Firebase";
export const Context = createContext();

export const Provider = (props) => {
  const [term, setTerm] = useState(" ");
  const [book, setBook] = useState({
    title: "",
    src: "",
    prix: "",
    rating: "",
    desc: "",
  });

  return (
    <Context.Provider value={[term, setTerm]}>
      {props.children}
    </Context.Provider>
  );
};

//for basket
export const BasketContext = createContext();

export const BasketProvider = (props) => {
  const [basket, setBasket] = useState(
    localStorage.getItem("basket")
      ? JSON.parse(localStorage.getItem("basket"))
      : []
  );

  useEffect(() => {
    localStorage.setItem("basket", JSON.stringify(basket));
  }, [basket]);

  return (
    <BasketContext.Provider value={[basket, setBasket]}>
      {props.children}
    </BasketContext.Provider>
  );
};

//for user
export const UserContext = createContext();

export const UserProvider = (props) => {
  const [user, setUser] = useState(null);
  auth.onAuthStateChanged((user) => setUser(user));

  return (
    <UserContext.Provider value={[user, setUser]}>
      {props.children}
    </UserContext.Provider>
  );
};
